import { useRef, useEffect, useState } from "react";
import mockupSrc from "../../assets/images/ios-mockup.png";
import bgSrc from "../../assets/images/ic-fourthpage-bg.svg";
import saveSrc from "../../assets/images/g1cash-save.png";
import introSrc from "../../assets/images/g1cash-intro.png";
import storeSrc from "../../assets/images/g1cash-store.png";
import "./fourthpage.css";
import { IosMockup } from "../../constants/icons";

const FourthPageMobile = () => {
    const fourthPageMobileRef = useRef(null);
    const [show, setShow] = useState(false);

    useEffect(() => {
        //for interaction
        const observer = new IntersectionObserver(
            (entries) => {
                entries.map((entry) => {
                    if (entry.isIntersecting && !entry.target.classList.contains("show")) {
                        setShow(true);
                    }
                });
            },
            { threshold: 0.5 }
        );
        observer.observe(fourthPageMobileRef.current);
    }, []);

    return (
        <div className={`${show ? "show" : ""} fourth-mobile-page`} ref={fourthPageMobileRef}>
            <img src={bgSrc} className="fourth-page-bg" />
            <div className="fourth-page-top">
                <div className="fourth-title title">
                    {"An innovative\n"}
                    <span>Consumption lifestyle!</span>
                </div>
                <div className="fourth-subtitle subtitle">
                    {"Unlock a new level of online and offline\n consumption lifestyle with "} <span>G1CASH.</span>{" "}
                </div>
            </div>
            <div className="fourth-page-bottom">
                <img src={mockupSrc} className="fourth-page-phone" />
                <img src={introSrc} className="fourth-page-bg-save" />
                <img src={saveSrc} className="fourth-page-bg-save second" />
                <img src={storeSrc} className="fourth-page-bg-save third" />
            </div>
        </div>
    );
};

export default FourthPageMobile;
